import { Button, Group, Select, Stack, Textarea, TextInput } from '@mantine/core';
import { IconDeviceFloppy } from '@tabler/icons-react';
import RichTextEditorInput from 'components/RichTextEditorInput';
import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { replace, useNavigate, useParams } from 'react-router-dom';
import { pathnames } from 'routes/dacum';
import { useCompetencyManagementStore } from 'store/competencyManagement';
import { CompetencyDataForm } from 'types/dacum/competencyManagement';

const CompetencyForm = () => {
  const params = useParams();
  const navigate = useNavigate();

  const { formData, mode, setFormData, setMode } = useCompetencyManagementStore();

  const { id } = params;

  const {
    control,
    handleSubmit,
    formState: { errors, isSubmitting }
  } = useForm<CompetencyDataForm>({
    //   resolver: zodResolver(coursePlanSchema),
    defaultValues: {
      description: formData.description,
      schoolName: formData.schoolName,
      keyAction: formData.keyAction
    },
    mode: 'all',
    reValidateMode: 'onChange'
  });

  const onSubmit = (data: CompetencyDataForm) => {
    setFormData(data);
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack gap={32}>
          <Stack gap={16}>
            <Controller
              name='schoolName'
              control={control}
              render={({ field }) => (
                <TextInput
                  label='School Name'
                  placeholder='Enter school name'
                  error={errors.schoolName?.message}
                  disabled={mode === 'view'}
                  {...field}
                />
              )}
            />
            <Controller
              name='msCompetencyManagementID'
              control={control}
              render={({ field }) => (
                <Select
                  label='Competency Management'
                  placeholder={'Select competency management'}
                  data={[]}
                  error={errors.msCompetencyManagementID?.message}
                  value={field.value}
                  onChange={(value) => field.onChange(value || '')}
                />
              )}
            />
            <Controller
              name='learningPathProgramID'
              control={control}
              render={({ field }) => (
                <Select
                  label='Learning Path Program'
                  placeholder={'Select learning path program'}
                  data={[]}
                  error={errors.learningPathProgramID?.message}
                  value={field.value}
                  onChange={(value) => field.onChange(value || '')}
                />
              )}
            />
            <Controller
              name='description'
              control={control}
              render={({ field }) => (
                <Textarea
                  label='Description'
                  placeholder='Enter course description'
                  error={errors.description?.message}
                  minRows={3}
                  disabled={mode === 'view'}
                  {...field}
                />
              )}
            />
            <Controller
              name='keyAction'
              control={control}
              render={({ field }) => (
                <RichTextEditorInput
                  label='Key Actions'
                  placeholder='Enter key action'
                  error={errors.keyAction?.message}
                  disabled={mode === 'view'}
                  {...field}
                />
              )}
            />
          </Stack>

          <Group justify='flex-end'>
            <Button variant='outline' onClick={() => navigate(-1)}>
              {mode === 'view' ? 'Back' : 'Cancel'}
            </Button>
            {mode !== 'view' && (
              <Button
                type='submit'
                loading={isSubmitting}
                size='md'
                leftSection={<IconDeviceFloppy />}
              >
                {mode === 'add' ? 'Create' : 'Update'} Competency
              </Button>
            )}
            {mode === 'view' && (
              <Button
                size='md'
                onClick={() => {
                  setMode('edit');
                  replace(`${pathnames.competencyManagement}/edit/${id}`);
                }}
              >
                Edit Course Plan
              </Button>
            )}
          </Group>
        </Stack>
      </form>
    </>
  );
};

export default CompetencyForm;
